import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { LanguageService, Reports, ReportService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class ReportsResolver implements Resolve<Reports> {
  constructor(private languageService: LanguageService, private reportService: ReportService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return forkJoin({
      items: this.reportService.getReports(this.languageService.language),
      nodes: this.reportService.getTreeNodes(this.languageService.language)
    });
  }
}
